"use strict";
/**
 * @fileoverview Statistics request types
 * Defines request parameters for statistics endpoints
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeGranularity = void 0;
/**
 * Time granularity for statistics aggregation
 */
var TimeGranularity;
(function (TimeGranularity) {
    TimeGranularity["WEEK"] = "week";
    TimeGranularity["MONTH"] = "month";
    TimeGranularity["YEAR"] = "year";
    TimeGranularity["CUSTOM"] = "custom";
})(TimeGranularity || (exports.TimeGranularity = TimeGranularity = {}));
